import { render } from "./mobile.vue?vue&type=template&id=47aed2b8&scoped=true"
import script from "./mobile.vue?vue&type=script&lang=js"
export * from "./mobile.vue?vue&type=script&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=47aed2b8&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47aed2b8"]])

export default __exports__